import React from 'react';
import { Alert } from 'antd';

// SWSMTR-3075: aviso fijo mientras el SAT presente esta intermitencia conocida.
// Actualizar/retirar aquí cuando Soporte confirme que ya no aplica.
export const PORTAL_INTERMITTENCY_MESSAGE =
    'El Portal del SAT está presentando intermitencias y en ocasiones puede indicar que no '
    + 'hay archivos disponibles para descargar aunque sí existan. Si esto te ocurre, te '
    + 'recomendamos reintentar tu descarga más tarde.';

const PortalIntermittencyNotice = () => (
    <Alert
        type="info"
        showIcon
        banner
        message={PORTAL_INTERMITTENCY_MESSAGE}
        className="portal-intermittency-notice"
        style={{ marginBottom: 16 }}
    />
);

export default PortalIntermittencyNotice;
